<template>
  <div
    class="w100 pl20 pr20 pt20 pb20 shocase-page-container"
    v-loading="loading"
  >
    <div class="">
      <el-button type="primary" @click="addCase">新增方案</el-button>
    </div>

    <div class="showcase-table">
      <el-table
        class="w100 mt20 table"
        header-row-class-name="table-head"
        row-class-name="cu-p"
        stripe
        :data="list"
      >
        <el-table-column
          align="center"
          prop="deskName"
          label="首页方案名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="roleNames"
          label="应用角色"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="updateTime"
          label="修改时间"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="getPageDeskVo(scope.row)"
              :loading="goingToShowcaseConfig && clickRow.deskId===scope.row.deskId"
              :disabled="goingToShowcaseConfig"
            >排版
            </el-button>
            <el-button
              type="text"
              @click="editCase(scope.row)"
            >编辑
            </el-button>
           
            <el-button
              type="text"
              @click="deleteCase(scope.row)"
            ><span style="color: red">删除</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination
        background
        @current-change="changePage"
        :current-page="current"
        :page-size="size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      :modal="false"
      class="selfModal"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :title="title"
      width="480px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="formValidate"
          :rules="ruleValidate"
          ref="formValidate"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="方案名称" prop="deskName">
            <el-input v-model="formValidate.deskName"></el-input>
          </el-form-item>
          <el-form-item label="应用角色" prop="roleIds">
            <el-select
              size="mini"
              v-model="formValidate.roleIds"
              multiple
              placeholder="请选择角色"
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="String(item.roleId)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="subDisabled"
          size="small"
          @click="submit"
          >确 认</el-button
        >
        <el-button style="margin-left: 8px" size="small" @click="closeDialog"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      v-if="showcaseConfig"
      class="selfModal"
      :close-on-click-modal="false"
      :visible.sync="showcaseConfig"
      :title="showcaseConfigData.deskName"
      width="1330px"
      top="20px"
      :before-close="closeShowcaseDialog"
    >
      <ShowcaseConfig 
        ref="showcaseConfig"
        :showcaseConfigData="showcaseConfigData" 
        @closeShowcaseConfig="closeShowcaseConfig"
      />
    </el-dialog>

    
  </div>
</template>

<script>
import { getList } from "@/api/system/role";
import { getPlanDesktopVoList, createPlanDesktop, deletePlanDesktop, editPlanDesktop } from "@/api/management/showcase";
import ShowcaseConfig from "./showcaseConfig";
export default {
  name: "showcase",
  components: { ShowcaseConfig },
  data() {
    return {
      current: 1,
      size: 10,
      total: 0,
      list: [],
      title: "新增方案",
      showDialog: false,
      formValidate: {
        deskName: "",
        roleIds: [],
        deskId: '',
      },
      ruleValidate: {
        deskName: [{ required: true, message: "不能为空", trigger: "blur" }],
        roleIds: [
          { required: true, message: "请选择应用角色", trigger: "blur" },
        ],
      },
      roleList: [],
      subDisabled: false,
      loading: false,
      goingToShowcaseConfig: false,
      showcaseConfig: false,
      showcaseConfigData: {
        deskId: '',
        deskName: '',
        deskType: '',
      },
      clickRow: {},
    };
  },
  created() {
    this.getRoleList();
    this.initCaseList();
  },
  computed: {},
  methods: {
    getPageDeskVo(row){
      this.clickRow = row;
      this.goingToShowcaseConfig = true
      this.$store.dispatch("getPageDeskVo", row.deskId)
      .then(() => {
        this.goShowcaseConfig(row)
      }).catch((msg) => {
        this.$message.error(msg)
      }).finally(() => {
        this.goingToShowcaseConfig = false;
      })
    },
    goShowcaseConfig(row) {
      this.showcaseConfigData.deskId = row.deskId;
      this.showcaseConfigData.deskName = row.deskName;
      this.showcaseConfigData.deskType = 'role';
      this.showcaseConfig = true;
    },
    closeShowcaseConfig(){
      this.showcaseConfig = false; 
    },
    closeShowcaseDialog(){
      this.$refs.showcaseConfig.closeShowcaseConfig()
    },
    initCaseList(){
      this.current = 1;
      this.getCaseList()
    },
    getCaseList() {
      this.loading = true
      let obj = {
        current: this.current,
        size: this.size,
      }
      getPlanDesktopVoList(obj)
      .then(({data}) => {
        if(data.code===0){
          this.list = data.data.records;
          this.total = data.data.total;
        }else {
          this.$message.error(data.msg)
        }
      })
      .finally(() => {this.loading = false})
    },
    changePage(page) {
      this.current = page;
      this.getCaseList()
    },
    getRoleList() {
      getList().then(({ data }) => {
        if (data.code == 0) {
          this.roleList = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    addCase() {
      this.title = "新增方案";
      this.showDialog = true;
    },
    editCase(row){
      this.title = "编辑方案";
      this.formValidate = {
        deskName: row.deskName,
        deskId: row.deskId,
        roleIds: row.roleIds.split(','),
      };
      this.showDialog = true;
    },
    deleteCase(row){
      this.$confirm(`确定删除${row.deskName}吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletePlanDesktop({deskId: row.deskId})
        .then(({data}) => {
          if(data.code == 0 ){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.initCaseList();
          }else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    closeDialog() {
      this.showDialog = false;
      // this.$refs.formValidate.resetFields();
      this.formValidate = {
        deskName: '',
        deskId: '',
        roleIds: [],
      }
    },
    submit() {
      this.$refs.formValidate.validate((valid) => {
        if(valid){
          if(this.title==='新增方案'){
            createPlanDesktop(this.formValidate)
            .then(({data}) => {
              if(data.code==0){
                this.$message.success('添加方案成功')
                this.closeDialog()
                this.initCaseList()
              }else {
                this.$message.error(data.msg)
              }
            })
          }else {
            editPlanDesktop(this.formValidate)
            .then(({data}) => {
              if(data.code==0){
                this.$message.success('编辑方案成功')
                this.closeDialog()
                this.initCaseList()
              }else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./showcase.less";
</style>
